import { render, staticRenderFns } from "./SectionFaq.vue?vue&type=template&id=2b064a65&scoped=true&"
import script from "./SectionFaq.vue?vue&type=script&lang=js&"
export * from "./SectionFaq.vue?vue&type=script&lang=js&"
import style0 from "./SectionFaq.vue?vue&type=style&index=0&id=2b064a65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b064a65",
  null
  
)

export default component.exports